import Lightbox from "yet-another-react-lightbox";

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import React from "react";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import "yet-another-react-lightbox/plugins/counter.css";

import PhotoAlbum from "react-photo-album";

import "yet-another-react-lightbox/styles.css";

import "yet-another-react-lightbox/plugins/counter.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";

const photosG = [
  {
    src: "./pictures/restware/Restware_1.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_11.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_12.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_13.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_15.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_18.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_19.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_2.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_20.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_21.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_22.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_23.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_24.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_25.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_26.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_27.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_28.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_29.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_3.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_30.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_31.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_32.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_33.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_34.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_35.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_36.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_37.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_38.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_39.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_4.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_40.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_41.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_42.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_43.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_44.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_47.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_5.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_50.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_51.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_52.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_53.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_54.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_55.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_56.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_57.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_58.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_59.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_6.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_7.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_70.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_71.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_75.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_8.jpg",
    width: 2000,
    height: 1500,
  },
  {
    src: "./pictures/restware/Restware_9.jpg",
    width: 1500,
    height: 2000,
  },
  {
    src: "./pictures/restware/steine.jpg",
    width: 1000,
    height: 750,
  },
];

const photos = [
  {
    src: "./pictures/restware/klein/resized_Restware_1.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_11.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_12.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_13.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_15.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_18.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_19.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_2.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_20.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_21.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_22.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_23.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_24.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_25.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_26.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_27.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_28.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_29.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_3.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_30.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_31.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_32.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_33.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_34.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_35.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_36.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_37.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_38.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_39.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_4.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_40.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_41.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_42.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_43.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_44.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_47.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_5.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_50.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_51.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_52.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_53.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_54.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_55.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_56.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_57.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_58.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_59.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_6.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_7.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_70.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_71.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_75.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_8.jpg",
    width: 500,
    height: 375,
  },
  {
    src: "./pictures/restware/klein/resized_Restware_9.jpg",
    width: 500,
    height: 666,
  },
  {
    src: "./pictures/restware/klein/resized_steine.jpg",
    width: 500,
    height: 375,
  },
];

export default function SaleInventory() {
  const [open, setOpen] = React.useState(false);
  const [index, setIndex] = React.useState(0);

  const fullscreenRef = React.useRef(null);

  return (
    <div style={{ padding: "25px" }}>
      <PhotoAlbum
        layout="rows"
        photos={photos}
        onClick={({ index }) => {
          setIndex(index);
          setOpen(true);
        }}
      />
      <Lightbox
        index={index}
        open={open}
        close={() => setOpen(false)}
        slides={photosG}
        plugins={[Counter, Fullscreen]}
        counter={{ container: { style: { top: "unset", bottom: 0 } } }}
        fullscreen={{ ref: fullscreenRef }}
        on={{
          click: () => fullscreenRef.current?.enter(),
        }}
      />
    </div>
  );
}
